import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['flashMessage']

  connect() {
    $(this.flashMessageTarget).hide().delay(200).fadeIn().delay(5000).fadeOut()
  }
}